"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SuccessIcon = function SuccessIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "40",
    viewBox: "0 0 20 40",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 28C7.125 28 4.5 26.5 3.0625 24C1.625 21.5312 1.625 18.5 3.0625 16C4.5 13.5312 7.125 12 10 12C12.8438 12 15.4688 13.5312 16.9062 16C18.3438 18.5 18.3438 21.5312 16.9062 24C15.4688 26.5 12.8438 28 10 28ZM13.5312 18.5312H13.5C13.8125 18.25 13.8125 17.7812 13.5 17.4688C13.2188 17.1875 12.75 17.1875 12.4688 17.4688L9 20.9688L7.53125 19.5C7.21875 19.1875 6.75 19.1875 6.46875 19.5C6.15625 19.7812 6.15625 20.25 6.46875 20.5312L8.46875 22.5312C8.75 22.8438 9.21875 22.8438 9.53125 22.5312L13.5312 18.5312Z",
    fill: "#387C2B"
  }));
};

var _default = SuccessIcon;
exports["default"] = _default;